import { Component, EventEmitter, HostListener, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemService } from '@services/item.service';
import { NotificationService } from '@services/notification.service';
import { QuestionService } from '@services/question.service';
import { WebErrorService } from '@services/webError.service';
// import { Editor } from 'ngx-editor';
import { Subscription } from 'rxjs';
import { GlobalToolbarConfig } from 'src/app/shared/addnewquestion';
import { CkeditorConfig, QuestionSubTypeIdEnum, QuestionTypeIdEnum } from 'src/app/shared/config/questions.config';
import { TranslateService } from '@ngx-translate/core';
import * as Editor from '../../../../assets/ckeditor';
import Adapter from '../ckeditorAdapter';

@Component({
  selector: 'app-items-descriptive-plain-text',
  templateUrl: './items-descriptive-plain-text.component.html',
  styleUrls: ['./items-descriptive-plain-text.component.scss']
})
export class ItemsDescriptivePlainTextComponent implements OnInit {
  toolbar = GlobalToolbarConfig;

  reuseProp = {
    questionuuId: 'questionuuId',
    questiondescription: 'questiondescription',
    description: 'description',
    correctPoints: 'correctPoints',
    maximumcharacterForFreetext: 'maximumcharacterForFreetext',
    itemId: 'itemId',
    penaltyPoints: 'penaltyPoints',
    minScoreIfAttempt: 'minScoreIfAttempt',
    scoringTypeExactMatch: 'scoringTypeExactMatch'
  };

  display = true;
  itemId: string;
  questionId: string;
  userForm: FormGroup;
  // questionEditor: Editor;
  isListMode: boolean = false;
  isEditMode: boolean = false;
  private routerSubscription: Subscription;
  ckeditorConfig = CkeditorConfig;
  isCkeditorLoading: boolean = true;
  QuestionScoringType: any;
  @Output() postCreated = new EventEmitter();
  @ViewChild("myEditor") myEditor: any;
  public Editor: any = Editor;
  points: any;
  QuestionSubTypeIdEnum = QuestionSubTypeIdEnum;
  QuestionTypeIdEnum = QuestionTypeIdEnum;
  errorMessage;
  public uploadedFileNames = [];
  QuestionImages = []
  imageId: number = 1;
  constructor(private router: Router,
    private routerstate: ActivatedRoute,
    public questionService: QuestionService,
    private notificationService: NotificationService,
    public itemservice: ItemService,
    private webErrorService: WebErrorService,
    public translate: TranslateService,
        private activatedRoute: ActivatedRoute
  ) {
    this.routerSubscription = this.routerstate?.parent?.params?.subscribe((data) => {
      this.itemId = data.id;
    });

    this.questionId = sessionStorage.getItem(this.reuseProp.questionuuId);
    if (!this.questionId) {
      this.questionId = this.router.getCurrentNavigation()?.extras?.state?.questionId;
    }

    this.userForm = new FormGroup({
      ansRenderCount: new FormControl(0),
      questionOrder: new FormControl(0),
      questionSubTypeId: new FormControl(QuestionSubTypeIdEnum.Descriptive),
      questionTypeId: new FormControl(QuestionTypeIdEnum.Descriptive),
      questiondisplayoptions: new FormControl('Vertical'),
      active: new FormControl(true),
      autoScoring: new FormControl(false),
      allowCheckAnswer: new FormControl(false),
      shuffleOption: new FormControl(false),
      [this.reuseProp.scoringTypeExactMatch]: new FormControl('false'),
      [this.reuseProp.questiondescription]: new FormGroup({ description: new FormControl('', Validators.required), mediaURL: new FormControl([""]), file_name: new FormControl([""]) }),
      [this.reuseProp.itemId]: new FormControl(''),
      [this.reuseProp.correctPoints]: new FormControl(0, Validators.required),
      [this.reuseProp.maximumcharacterForFreetext]: new FormControl(0, Validators.required),
      [this.reuseProp.penaltyPoints]: new FormControl(0),
      [this.reuseProp.minScoreIfAttempt]: new FormControl(0,Validators.required),
      questionImages: new FormControl('')
    });

    this.questionService.getQuestionScoringType().subscribe(d => {this.QuestionScoringType = d.data})


  }

  onReady(editor) {
    // editor.ui
    //   .getEditableElement()
    //   .parentElement.insertBefore(
    //     editor.ui.view.toolbar.element,
    //     editor.ui.getEditableElement()
    //   );

    sessionStorage.setItem('ImageUploadFileSizeErr', 'false');
    sessionStorage.setItem('imageUploadErr', 'false');
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      const adapter = new Adapter(loader, editor.config, this.itemservice);
      this.errorMessage = ''
      adapter.upload().catch((error) => {
        if (error === '') {
          if (sessionStorage.getItem('ImageUploadFileSizeErr') == 'true') {
            this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          }

          if (sessionStorage.getItem('imageUploadErr') == 'true') {
            this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          }
        }
      });
      adapter.upload().then(res=>{
        this.uploadedFileNames.push(res.fileName)
        this.QuestionImages.push({"uniqueId": "#image" + this.imageId++ , "imageName": res.fileName, "base64": res.default})
      })
      return adapter;
    }
  }

  onClick(event) {
    if (this.errorMessage && event) this.errorMessage = false;
  }

  ngOnInit(): void {
    // this.questionEditor = new Editor();
    if (this.questionId) {
      this.isEditMode = true;
      const questionServiceGetSubscription: Subscription = this.questionService
        .getQuestion(this.itemId, this.questionId)
        .subscribe((resdata) => {
          this.userForm.patchValue(resdata.data);
          this.userForm.controls[this.reuseProp.scoringTypeExactMatch].setValue(JSON.stringify(resdata.data.scoringTypeExactMatch));
          questionServiceGetSubscription.unsubscribe()
        },
          (error) => {
            this.webErrorService.handleAPIErrors(error);
          }
        );
    }
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 ||(k >= 48 && k <= 57) ||  k == 46);
  }

  replace() {
    const numvalue = (this.userForm.controls[this.reuseProp.correctPoints].value).toString();

    console.log(numvalue);

    console.log(this.userForm.controls[this.reuseProp.correctPoints].value);
  }
  replace2Decimal(event: any, o?: any, type?: any){
    let value = event.target.value;
    if (event.key == '.') value = value + event.key;
    if(value == '.') value = "";

    var ponto = value.split('.').length;

    if (ponto > 2) value = value.substr(0, (value.length)-1);

    value = value.replace(/[^0-9.-]/,'');

    if (ponto == 2) value = value.substr(0,(value.indexOf('.')+3));

    let num = value.substr(value.length - 1);
    if (type == 'options') {
      if (num != '.') this.userForm.controls[this.reuseProp.correctPoints].patchValue(parseFloat(value));
    }
    if (type == 'minScore') {
      if (num != '.' && value != '') this.userForm.controls[this.reuseProp.minScoreIfAttempt].patchValue(parseFloat(value));
    }
  }

  validateInput(event, o?, type?) {
    const inputElement = event.target;
    const value = inputElement.value;

    const regex = /^\d{0,4}(\.\d{0,2})?$/;
    const inputVal = inputElement.value.split('.')
    const beforeDecimal = inputVal[0]
    const afterDecimal = inputVal[1]
    console.log('value',value)
    if (!regex.test(value)) {
      inputElement.value = value.slice(0, -1);
      if(type == 'options') this.userForm.controls[this.reuseProp.correctPoints].patchValue(parseFloat(inputElement.value));
      if(type == 'minimumScore') this.userForm.controls[this.reuseProp.minScoreIfAttempt].patchValue(parseFloat(inputElement.value));
      if(beforeDecimal.length == 5 && afterDecimal.length > 1){
        inputElement.value = ''
        if(type == 'options') this.userForm.controls[this.reuseProp.correctPoints].patchValue(0);
        if(type == 'minimumScore') this.userForm.controls[this.reuseProp.minScoreIfAttempt].patchValue(0);
      }
    }
  }


  back() {
    this.postCreated.emit('false');
    this.display = false;
    // this.questionEditor.destroy();
  }

  saveQuestion() {
    this.userForm.controls[this.reuseProp.itemId].setValue(sessionStorage.getItem(this.reuseProp.itemId));
    // this.userForm.controls[this.reuseProp.scoringTypeExactMatch].setValue(JSON.parse(this.userForm.controls[this.reuseProp.scoringTypeExactMatch].value));

    let question = this.userForm.value.questiondescription['description'];
    let question1 = question;

    if (question1.length === 0) {
      this.webErrorService.customErrors(this.translate.instant('questions.fillInTheBlanks.errMsg1'), true, 'warn')
      // this.notificationService.warn(`Question field is mandatory`);
      return;  // Used to display alert message
    }

    if (this.QuestionImages.length > 0) {
      this.QuestionImages.forEach(ele => {

        question1 = question1.replace(ele.base64, ele.uniqueId)

        let startIndex = ele.base64.lastIndexOf('base64,');
        ele.base64 = ele.base64.substring(startIndex +7)
      })
    }
    this.userForm.value.questiondescription['description'] = question1;
    this.userForm.value.questionImages = this.QuestionImages;

    this.userForm.value.questiondescription['file_name'] = this.uploadedFileNames;

    if (this.isEditMode) {
      const questionServiceUpdateSubscription: Subscription = this.questionService.updateQuestion(this.userForm.value, this.itemId, this.questionId).subscribe(
        (resData) => {
          // this.questionService.reloadList.next(true);
          this.itemservice.editedGetItem(resData.data);
          this.notificationService.success(resData?.message);
          // this.itemservice.questionCountUpdate.next(true);
          // this.questionService.reloadList.next(true);
          this.isListMode = true;
          questionServiceUpdateSubscription.unsubscribe()
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        });
    }
    else {
      const questionServicePostSubscription: Subscription = this.questionService.addQuestion(this.userForm.value, this.itemId).subscribe(
        (resData) => {

          // this.questionService.reloadList.next(true);
          this.isEditMode = true;
          this.notificationService.success(resData?.message);
          // this.itemservice.questionCountUpdate.next(true);
          // this.questionService.reloadList.next(true);
          this.isEditMode = true;
          this.isListMode = true;
          questionServicePostSubscription.unsubscribe()
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        });
    }
  }

  onCkeditorReady() {
    this.isCkeditorLoading = false;
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}

